var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"msg-long-msg",class:{
    'select-none': _vm.selectNone
  }},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.processedText)}}),(_vm.isTransLate())?_c('msg-text-translate',{attrs:{"data":_vm.longMessage}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }